import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles(theme => ({
	saveButton: {
		fontSize: "14px",
		color: colors.gray[0],
		padding: theme.spacing(1, 2)
	},
	validationButton: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		...ColorUtil.getBackgroundAndContrastColor(colors.yellow[400]),
		height: theme.spacing(2.75),
		borderRadius: theme.spacing(0.5),
		minWidth: 34,
		padding: theme.spacing(1, 1.5),
		fontSize: theme.spacing(1.5),
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor(colors.yellow[300]),
			cursor: "pointer"
		}
	},
	validationButtonText: {
		fontSize: theme.spacing(1.75),
		color: colors.gray[0],
		fontWeight: 500,
		paddingLeft: theme.spacing(0.5),
		height: "100%",
		paddingBottom: theme.spacing(2.75)
	},
	picture: {
		width: "60%"
	},
	textValidationDialog: {
		fontSize: theme.spacing(2),
		lineHeight: "24px",
		fontWeight: 400,
		color: colors.gray[700]
	},
	validationDialogCancelButton: {
		padding: theme.spacing(1.25, 4),
		fontSize: theme.spacing(1.75),
		height: theme.spacing(5)
	},
	validationDialogSaveButton: {
		padding: theme.spacing(1.25, 4),
		...ColorUtil.getBackgroundAndContrastColor(colors.red[50]),
		opacity: 1,
		fontSize: theme.spacing(1.75),
		height: theme.spacing(5),
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor(colors.red[200])
		}
	},
	validationDialogActions: {
		marginTop: theme.spacing(2),
		gap: theme.spacing(3)
	},
	warningDialogText: {
		color: colors.gray[600],
		fontSize: "14px",
		fontWeight: 400,
		lineHeight: "24px"
	},
	warningDialogLinkContainer: {
		borderRadius: "4px",
		padding: "8px",
		...ColorUtil.getBackgroundAndContrastColor(colors.purple[100]),
		gap: "4px",
		cursor: "pointer"
	},
	warningDialogLinkText: {
		fontWeight: 400,
		fontSize: "14px",
		lineHeight: "20px",
		color: colors.purple[600]
	},
	warningDialogLinkIcon: {
		width: "12px",
		height: "12px",
		color: colors.purple[600]
	}
}))

export default useStyles
